import { RedirectMechanismType } from '@graphql/generated';
import { RedirectMechanismProps } from './HotelBooking.types';

export function getValidBookingLink(bookingLink: string | undefined): URL | undefined {
  if (!bookingLink) {
    return undefined;
  }
  // Ensure the URL string includes a protocol
  if (!/^https?:\/\//i.test(bookingLink)) {
    bookingLink = 'https://' + bookingLink;
  }
  try {
    return new URL(bookingLink);
  } catch (error) {
    return undefined;
  }
}

/**
 * Extracts the primary redirect mechanism (excluding 'partnerSearch') and the interceptor redirect (if any).
 *
 * @param redirectMechanisms - Array of redirect mechanism objects.
 * @returns An object containing the primary redirect and the interceptor redirect, if present.
 */
export function extractHotelPageUrlAndHotelSearchPageUrl(redirectMechanisms?: RedirectMechanismProps[] | null): {
  hotelPageUrl?: RedirectMechanismProps;
  hotelSearchPageUrl?: RedirectMechanismProps;
} {
  if (!redirectMechanisms) return { hotelPageUrl: undefined, hotelSearchPageUrl: undefined };
  return redirectMechanisms.reduce<{
    hotelPageUrl?: RedirectMechanismProps;
    hotelSearchPageUrl?: RedirectMechanismProps;
  }>((acc, redirect) => {
    if (redirect.type === RedirectMechanismType.partnerSearch) {
      acc.hotelSearchPageUrl ??= redirect;
    } else if (!acc.hotelPageUrl) {
      acc.hotelPageUrl = redirect;
    }
    return acc;
  }, {});
}
